<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <ap-field
    [title]="'securityType.name' | translate"
    [required]="true"
    [error]="nameField.touched && !!nameField.errors">
    <input appkit-field formControlName="name" [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - nameField.value.length }
      }}
    </div>
    @if (nameField.touched && nameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (nameField.touched && nameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.lettersRequired' | translate }}
      </div>
    }
  </ap-field>

  <ap-checkbox formControlName="isActive" class="my-2">
    {{ 'securityType.isActive' | translate }}
  </ap-checkbox>

  @if (!isParent() || !isEdit) {
    <gstar-security-types-combobox
      [required]="true"
      (selectSecurityType)="selectSecurityType($event)"
      (clearSecurityType)="clearSecurityType()"
      [onlyParent]="true"
      [placeholder]="'upsertSecurity.baseSecurityType' | translate"
      [nameValue]="parentName()" />
    @if (parentField.errors?.['required']) {
      <div class="ap-field-validation-error mt-n1">
        {{ 'formValidations.required' | translate }}
      </div>
    }
  }
</form>
